var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.isLoaded)?_c('div',{staticClass:"card-image center spinner"},[_c('Spinner')],1):_vm._e(),_c('img',{staticClass:"card-image",attrs:{"src":_vm.image,"alt":""},on:{"load":_vm.loaded,"error":_vm.error}})])}
var staticRenderFns = []

export { render, staticRenderFns }